import { Space, Typography, Button, Row, Col, Select, Layout, Card } from 'antd'
import { useEffect, useState } from 'react'
import { useQuery } from 'Hooks'
import { useRouteMatch, useLocation, useHistory } from 'react-router'
import { Link } from 'react-router-dom'
import Changelist from './Changelist'
import './Changelist.scss'

{ Title, Paragraph } = Typography

export default ->

  [branches, setBranches] = useState([])
  [source, setSource] = useState()
  [target, setTarget] = useState()
  [comparable, setComparable] = useState(false)
  [comparing, setComparing] = useState(false)
  [diffs, setDiffs] = useState({})

  history = useHistory()
  { pathname } = useLocation()
  { params: { spaceId }} = useRouteMatch()
  query = useQuery()

  useEffect(->
    (->
      setBranches(_.filter(await Weaver.Branch.list(), (branch) -> branch.id() isnt '$config'))
      if (qSource = query.get('source')) and (qTarget = query.get('target'))
        setSource(qSource)
        setTarget(qTarget)
        setComparing(true)
    )()
    undefined
  , [])

  useEffect(->
    if (source? and target?) and source isnt target
      setComparable(true)
    else
      setComparable(false)
    undefined
  , [source, target])

  branchOptions = (type) ->
    branches.map((branch) ->
      <Select.Option
        key={branch.id()}
        value={branch.id()}
        data-testid="#{type}-#{branch.id()}"
      >
        { branch.name() }
      </Select.Option>
    )

  <Layout style={{ padding: '16px', height: '100vh' }}>
    <Title level={4} style={{ flexGrow: 0 }}>Compare branches</Title>
    <Paragraph style={{ flexGrow: 0 }}>
      Choose a branch (e.g. Main) to see what's changed or to create a merge request.
      Changes are shown as if the source branch was being merged into the target branch.
    </Paragraph>
    <Card style={{ flexGrow: 1 }}>
      <Row style={{ marginBottom: '16px' }} gutter={16}>
        <Col lg={12}>
          <Select
            data-testid="source-branch"
            value={source}
            showSearch
            placeholder="Source branch"
            style={{ width: '100%' }}
            onChange={(value) ->
              setSource(value)
            }
          >
            { branchOptions('source') }
          </Select>
        </Col>
        <Col lg={12}>
          <Select
            showSearch
            value={target}
            data-testid="target-branch"
            placeholder="Target branch"
            style={{ width: '100%' }}
            onChange={(value) ->
              setTarget(value)
            }
          >
            { branchOptions('target') }
          </Select>
        </Col>
      </Row>
      <Row gutter={8}>
        <Col>
          <Button
            type="primary"
            disabled={not comparable}
            data-testid="compare-branches"
            onClick={->
              history.push("#{pathname}?source=#{source}&target=#{target}")
              setComparing(true)
            }
          >
            Compare
          </Button>
        </Col>
        {
          if comparing
            <Col>
              <Link to="/#{spaceId}/merge-requests/new?source=#{source}&target=#{target}">
                <Button>
                  Create merge request
                </Button>
              </Link>
            </Col>
        }
      </Row>
    </Card>
    {
      if comparing
        <Card className="changelist-container">
          <Changelist source={source} target={target} />
        </Card>
    }
  </Layout>
